import { useFeatureFlag } from "../../../hooks/useFeatureFlag/useFeatureFlag";
import { useOpalBranding } from "../../../hooks/useOpalBranding/useOpalBranding";
import { Flags } from "../../../feature-flags/flags";
import { Attention } from "@optimizely/axiom";
import { NEW_SUPPORT_TICKET_HREF } from "../../../constants/constants";

export const OpalCompleteRemovalAlert = ({ genAIDisabled = false }: { genAIDisabled?: boolean }) => {
    const { enabled } = useFeatureFlag(Flags.ENABLE_OPAL_REMOVAL_ALERT);
    const { opalName } = useOpalBranding();
    if (!(enabled && genAIDisabled)) {
        return null;
    }

    return (
        <Attention type="warning" className="push-triple--top">
            {opalName} is currently disabled, but {opalName} access may still be provisioned. To remove {opalName}{" "}
            entirely, please submit a{" "}
            <a href={NEW_SUPPORT_TICKET_HREF} target="_blank" rel="noreferrer">
                support ticket
            </a>
            .
        </Attention>
    );
};

OpalCompleteRemovalAlert.displayName = "OpalCompleteRemovalAlert";
